{
    "OnavailablestateLabel": "No estado disponível em:",
    "OnbusystateLabel": "Em estado ocupado sobre:",
    "OnnaordndstateLabel": "Em estado N\/A ou DND Sobre:",
    "OnwrapupLabel": "No estado de finalização sobre:",
    "OnavailablestateEnabledHiddenlabel": "O estado disponível sobre a configuração está ativado?",
    "OnbusystateEnabledHiddenlabel": "A configuração em estado ocupado sobre a configuração está habilitada?",
    "OnnaordndstateEnabledHiddenlabel": "A configuração On N\/A ou DND State Over está habilitada?",
    "OnwrapupEnabledHiddenlabel": "O estado de finalização sobre a configuração está ativado?",
    "OnavailablestatePlaceholder": "30 anos",
    "OnbusystatePlaceholder": "5m 0s",
    "OnnaordndstatePlaceholder": "3m 0s",
    "OnwrapupPlaceholder": "3m 0s",
    "ACDStateThresholds_SectionHeader": "Limites de estado de ACD",
    "ACDStateThresholds_SectionPara": "É possível ativar alarmes quando os agentes permanecem num determinado estado ACD durante demasiado tempo. Selecione os estados ACD que irão ativar um alarme abaixo e, em seguida, selecione a duração de ativação necessária.",
    "NAME": "ACDStateThresholds"
}